import * as React from "react";
import { hashCode } from "../../utils/hash";

let toggleBoxCounter = 0;

export interface IToggleBoxProps {
  label: string;
  value: string;
  cssClass?: string;
  onChangeCb?: (event: React.ChangeEvent) => void;
  inputType?: string;
  inputName?: string;
  hideToggleBox?: boolean;
  termCount?: number;
  refValue?: React.RefObject<HTMLInputElement>;
}

export class ToggleBox extends React.Component<IToggleBoxProps> {
  private _id: string;
  static defaultProps = {
    cssClass: "",
    onChangeCb: () => {},
    inputType: "checkbox",
    inputName: "togglebox",
    hideToggleBox: false,
  };

  constructor(props: IToggleBoxProps) {
    super(props);
    toggleBoxCounter += 1;
    this._id = `${hashCode(props.value, "togglebox")}${toggleBoxCounter}`;
  }

  public render() {
    const {
      label,
      value,
      onChangeCb,
      cssClass,
      hideToggleBox,
      termCount,
      refValue,
    } = this.props;
    return (
      <div
        className={
          `togglebox ${cssClass}`.trim() +
          (hideToggleBox ? " togglebox__inactive" : "")
        }
      >
        <input
          ref={refValue}
          id={this._id}
          className="togglebox__input"
          type={this.props.inputType}
          name={this.props.inputName}
          value={value}
          onChange={onChangeCb}
          disabled={hideToggleBox}
          aria-disabled={hideToggleBox}
        />
        <label htmlFor={this._id} className="togglebox__label">
          {label}
          {termCount != null ? `${" (" + termCount + ")"}` : ""}
        </label>
      </div>
    );
  }
}
